import SvgIcon from '@home/components/SvgIcon';
import React, { useMemo, useState } from 'react';
import { Bubble, Button, Modal } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';
import { mdContentToHtml, replaceGptText } from '@op/utils/text';
import { DBO_T } from '@op/utils/format';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';

export default function useFullDialog() {
  const [aigcContent, setAigcContent] = useState('');
  const { formatMessage } = useIntl();
  const [visible, setVisible] = useState(false);

  const renderHtml = useMemo(() => {
    if (!aigcContent) return null;

    const replacedSummary = replaceGptText(aigcContent);

    const { html } = mdContentToHtml(replacedSummary);

    return html;
  }, [aigcContent]);

  function FullDialog() {
    return (
      <Modal
        className="dbo-gpt-summary-modalbox"
        visible={visible}
        size={800}
        caption={
          <div className="dbo-gpt-summary-modal-title">
            {formatMessage({ id: 'GPT Summary' })}
            <Bubble
              closeOnScroll
              dark
              content={formatMessage({ id: 'Copy text' })}
            >
              <div
                className="dbo-gpt-summary-modal-icon"
                onClick={() => DBO_T.copyText(aigcContent, formatMessage)}
              >
                <SvgIcon
                  type="datalab-copy"
                  className="dbo-gpt-summary-modal-icons"
                />
              </div>{' '}
            </Bubble>
          </div>
        }
        onClose={() => {
          setVisible(false);
        }}
      >
        <Modal.Body>
          <FormatHtmlTextToReact
            className="dbo-gpt-summary-modal"
            text={renderHtml!}
          ></FormatHtmlTextToReact>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={() => {
              setVisible(false);
            }}
          >
            {formatMessage({ id: 'Confirm' })}
          </Button>
          <Button
            type="weak"
            onClick={() => {
              setVisible(false);
            }}
          >
            {formatMessage({ id: 'Cancel' })}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return {
    FullDialog,
    setAigcContent,
    setVisible,
    aigcContent,
  };
}
